import { Theme } from '@mui/material'

const useStyles = {
  footer: (theme: Theme) => ({
    position: 'absolute',
    bottom: 15,
    color: theme.palette.common.white,
    width: '100%',
    maxWidth: theme.breakpoints.values.xl,
    padding: '0 15px',
  }),
  footerLink: (theme: Theme) => ({
    color: theme.palette.common.white,
  }),
  inlineBlockTypography: {
    display: 'inline-block',
  },
}
export default useStyles
